import { useEffect } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { SVMChain } from '../../types';
import { ConnectionState } from '../../wallet/types';
import { DEFAULT_WALLET_CONNECTION } from '../constants';
import { translateErrorMessage } from '../../utils/common';
export function useSvmConnection({ walletConnection, setWalletConnection, toast, setIsWalletModalOpen, curEVMConnector, }) {
    const { autoConnect, connect, disconnect, publicKey, wallet, disconnecting, connecting, connected, signMessage, } = useWallet();
    // Sometimes select may not connect wallet in solana adapter
    useEffect(() => {
        if (walletConnection.network === SVMChain.Solana &&
            walletConnection.connectionState == ConnectionState.Connecting) {
            console.log('Connecting to Solana with', walletConnection.wallet);
            setTimeout(() => {
                connect()
                    .then(() => { })
                    .catch((err) => {
                    toast.error(`Failed to connect to ${walletConnection.network} with ${walletConnection.wallet}: ${translateErrorMessage(err)}`);
                    setWalletConnection(DEFAULT_WALLET_CONNECTION);
                });
            }, 500);
        }
    }, [walletConnection.network, walletConnection.connectionState, autoConnect]);
    // Solana wallet is connected
    useEffect(() => {
        if (publicKey &&
            !disconnecting &&
            connected &&
            !connecting &&
            walletConnection.connectionState !== ConnectionState.Disconnecting) {
            let newInfo = {};
            // for auto connect case
            if (!walletConnection.network &&
                !walletConnection.wallet &&
                wallet &&
                walletConnection.connectionState == ConnectionState.Disconnected) {
                newInfo = { wallet: wallet.adapter.name, network: SVMChain.Solana };
            }
            newInfo = {
                ...newInfo,
                connectionState: ConnectionState.Connected,
                address: publicKey.toString(),
            };
            setWalletConnection({ ...walletConnection, ...newInfo });
            curEVMConnector?.disconnect?.();
            setIsWalletModalOpen(false);
        }
    }, [wallet, publicKey, disconnecting, connected, connecting, walletConnection, curEVMConnector]);
    return {
        disconnectSolana: disconnect,
        publicKey,
        wallet,
        signMessage,
    };
}
